(function (module) {
    module.directive('scrollTop', ['$rootScope', function ($rootScope) {
        return {
            restrict: 'A',
            scope: {
                trigger: '=scrollTop'
            },
            link: function postLink(scope, elem, attr) {
                // var ev = scope.$watch('trigger', function () {
                //     console.log('scrolling top');
                //     elem[0].scrollTop = 0;
                // });
                var channel = 'scroll:' + scope.trigger.toString();

                var ev = $rootScope.$on(channel, function (ev, position) {
                    if (position) {
                        elem[0].scrollTop = position;
                    } else {
                        elem[0].scrollTop = 0;
                    }
                });
                scope.$on('$destroy', function () {
                    ev();
                });
            }
        };
    }]);
}(angular.module('emarket.commons')));
